import type { ProductDetails } from '@frontend/libs/types/product'

import useSiteConfiguration from '@frontend/libs/hooks/useSiteConfiguration'
import { parseHtml } from '@frontend/libs/utils'
import { Divider } from '@nextui-org/react'
import { __ } from '@wordpress/i18n'

import CareInstruction from './CareInstruction'

export function ProductMeta({
  product,
}: Readonly<{ product: ProductDetails }>) {
  const { isLoading, settings } = useSiteConfiguration()

  return (
    <div className="mb-10 grid grid-cols-1 gap-5 md:my-6">
      <a className="text-sm font-medium uppercase underline" href="/stores/">
        {__('Find in store', 'asavagroup')}
      </a>
      {product?.description && (
        <div className="text-sm uppercase">
          <span className="font-medium">{__('Description:')} </span>
          {parseHtml(product.description)}
        </div>
      )}
      {product?.information && (
        <div className="text-sm uppercase">
          <span className="font-medium">{__('Info:')} </span>
          {parseHtml(product.information)}
        </div>
      )}
      {product?.composition && (
        <div className="text-sm uppercase">
          <span className="font-medium">{__('Composition:')} </span>
          {parseHtml(product?.composition)}
        </div>
      )}
      {product?.productId && (
        <div className="text-sm uppercase">
          <span className="font-medium">{__('Product Code:')} </span>
          {product.productId}
        </div>
      )}
      {product?.brands && (
        <div className="text-sm uppercase">
          <span className="font-medium">{__('Brand:')} </span>
          {parseHtml(product.brands)}
        </div>
      )}
      {product?.collections && (
        <div className="text-sm uppercase">
          <span className="font-medium">{__('Collection:')} </span>
          {parseHtml(product.collections.join(', '))}
        </div>
      )}
      {product?.careInstruction && (
        <>
          <Divider />
          <CareInstruction {...product.careInstruction} />
        </>
      )}
      <Divider />
      <div>
        <a
          className="text-sm font-medium uppercase"
          href="/shipping-and-returns/"
        >
          {__('Shipping & Returns', 'asavagroup')}
        </a>
      </div>
      <Divider />
      <div>
        <span className="mb-4 block text-sm font-medium uppercase">
          {__('Need Help?')}
        </span>
        {isLoading && (
          <span className="block text-sm uppercase">
            {__('Loading...', 'asavagroup')}
          </span>
        )}
        {!isLoading && (
          <div className="space-y-2">
            {settings?.socialMedia.line && (
              <a
                className="block text-sm uppercase"
                href={settings.socialMedia.line}
                rel="noreferrer"
                target="_blank"
              >
                <span>{__('LINE OFFICIAL:', 'asavagroup')} </span>
                <span className="underline">
                  {__('ASAVAGROUP', 'asavagroup')}
                </span>
              </a>
            )}
            {settings?.contactInfo.phoneNumber && (
              <a
                className="block text-sm uppercase hover:underline"
                href={`tel:${settings?.contactInfo.phoneNumber}`}
              >
                <span>{__('TEL:', 'asavagroup')}</span>{' '}
                <span>{settings.contactInfo.phoneNumber}</span>
              </a>
            )}
            {settings?.contactInfo.businessHours && (
              <span className="block text-sm uppercase">
                {settings.contactInfo.businessHours}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
